import { styled } from 'styled-components';

export const Button = styled.button<{
  fullWidth?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
}>`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  height: 56px;
  background-color: ${({ theme, variant }) =>
    !variant || variant === 'contained' ? theme.colors.primary600 : 'transparent'};
  border: ${({ theme, variant }) =>
    variant === 'text'
      ? 'none'
      : !variant || variant === 'contained'
        ? `1px solid ${theme.colors.primary600}`
        : `2px solid ${theme.colors.primary600}`};
  color: ${({ theme, variant }) =>
    !variant || variant === 'contained' ? theme.colors.neutral : theme.colors.primary600};
  padding: ${({ variant }) => (variant === 'text' ? 0 : '0 16px')};
  border-radius: 8px;
  font-size: ${({ theme }) => theme.sizes.sm};
  font-weight: bold;
  cursor: pointer;
  transition:
    background-color,
    border-color,
    color 0.2s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
  white-space: nowrap;

  &:hover {
    background-color: ${({ theme, variant }) =>
      !variant || variant === 'contained' ? theme.colors.secondary500 : 'transparent'};
    border-color: ${({ theme, variant }) =>
      variant === 'text'
        ? 'none'
        : !variant || variant === 'contained'
          ? 'none'
          : theme.colors.secondary500};
    color: ${({ theme, variant }) =>
      variant === 'text'
        ? theme.colors.secondary500
        : !variant || variant === 'contained'
          ? theme.colors.neutral
          : theme.colors.secondary500};
  }
`;
